var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-to-top",attrs:{"id":"back-to-top"},on:{"click":function($event){_vm.scrollAction()}}},[_c('span',{staticClass:"icon-arrow-right-swiper"})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a86f3ea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./assets/js/components/BackToTop.vue
// module id = p/RV
// module chunks = 0